document.addEventListener('alpine:init', () => {
    Alpine.data('quoteSidebarContacts', () => ({
        changing: null,

        toggle(section) {
            if (this.changing === section) {
                this.close();
                return;
            }

            this.changing = section;
            this.$nextTick(() => {
                const select = this.$refs[`${section}Form`].querySelector('select');
                if (select?.tomselect) {
                    select.tomselect.focus();
                } else {
                    select?.focus();
                }
            });
        },

        close() {
            const section = this.changing;
            this.changing = null;
            this.$refs[`${section}Button`]?.focus();
        },
    }));

    Alpine.data('quoteSidebarMailing', (hasPhone, sendType) => ({
        mailingType: hasPhone ? 'initial' : 'vibba',
        sendType,
        restart: hasPhone,
        busy: false,
        error: '',

        init() {
            this.onHide = (event) => {
                if (this.busy) {
                    event.preventDefault();
                }
            };
            window.jQuery(this.$root).on('hide.bs.modal', this.onHide);
        },

        destroy() {
            window.jQuery(this.$root).off('hide.bs.modal', this.onHide);
        },

        async submit(form) {
            if (this.busy) {
                return;
            }

            const payload = new FormData(form);
            this.busy = true;
            this.error = '';

            try {
                await window.axios.post(form.action, payload, { headers: { Accept: 'application/json' } });
                window.location.reload();
            } catch (error) {
                this.error = Object.values(error.response?.data?.errors ?? {}).flat()[0]
                    ?? 'Meddelandet kunde inte skickas. Försök igen.';
                if (error.response?.status !== 422) {
                    window.SalesByteCaptureException?.(error);
                }
                this.busy = false;
            }
        },
    }));

    Alpine.data('quoteSidebarMenu', () => ({
        open: false,

        toggle() {
            if (this.open) {
                this.close(true);
                return;
            }

            this.open = true;
            this.$nextTick(() => {
                const selected = this.$refs.menu.querySelector('[aria-checked="true"]')
                    ?? this.$refs.menu.querySelector('button');
                selected?.focus();
            });
        },

        move(step) {
            const buttons = [...this.$refs.menu.querySelectorAll('button')];
            const index = buttons.indexOf(document.activeElement);
            buttons[(index + step + buttons.length) % buttons.length]?.focus();
        },

        close(restoreFocus = false) {
            this.open = false;
            if (restoreFocus) {
                this.$refs.toggle.focus();
            }
        },
    }));

    Alpine.data('quoteSidebarPanel', (panelId, initiallyExpanded = true) => ({
        expanded: initiallyExpanded,

        init() {
            try {
                const saved = sessionStorage.getItem(`quote-sidebar:${panelId}`);
                if (saved !== null) {
                    this.expanded = saved === 'true';
                }
            } catch (error) {
                // The panels still work when browser storage is unavailable.
            }
        },

        toggle() {
            this.expanded = !this.expanded;
            try {
                sessionStorage.setItem(`quote-sidebar:${panelId}`, String(this.expanded));
            } catch (error) {
                // Remembering expansion is optional.
            }
        },
    }));

    Alpine.data('quoteTeamMentions', (people) => ({
        query: null,
        start: 0,
        active: 0,

        get matches() {
            if (this.query === null) {
                return [];
            }

            const query = this.query.toLocaleLowerCase('sv');

            return people.filter((name) => name.toLocaleLowerCase('sv').includes(query)).slice(0, 6);
        },

        track(textarea) {
            const before = textarea.value.slice(0, textarea.selectionStart);
            const mention = before.match(/(?:^|\s)@([^\s@]*)$/);
            this.query = mention ? mention[1] : null;
            this.start = mention ? textarea.selectionStart - mention[1].length - 1 : 0;
            this.active = 0;
        },

        move(step) {
            this.active = (this.active + step + this.matches.length) % this.matches.length;
        },

        pick(name) {
            const textarea = this.$refs.note;
            const end = textarea.selectionStart;
            textarea.value = `${textarea.value.slice(0, this.start)}@${name} ${textarea.value.slice(end)}`;
            const caret = this.start + name.length + 2;
            textarea.setSelectionRange(caret, caret);
            textarea.dispatchEvent(new Event('input'));
            textarea.focus();
            this.close();
        },

        close() {
            this.query = null;
        },
    }));

    Alpine.data('quoteSidebarDelete', (redirectUrl) => ({
        busy: false,
        error: '',

        async submit() {
            if (this.busy || !window.confirm('Är du säker?')) {
                return;
            }

            this.busy = true;
            this.error = '';
            try {
                await window.axios.post(this.$el.action, new FormData(this.$el));
                window.location.assign(redirectUrl);
            } catch (error) {
                this.error = 'Något gick fel, försök igen!';
                window.SalesByteCaptureException?.(error);
                this.busy = false;
            }
        },
    }));
});
